const dictionary = { 
    common:{
        next: "Siguiente",
        test:"Iniciar evaluación",
        closed: "Cerrar",
        end_evaluation:"Terminar evaluación",
        start:"Comenzar",
        start_test:'Comenzar prueba',
        continue:'Continuar',
        accept:'Aceptar',
        loading:'Cargando...',
        saving:'Guardando...',
        next_page:'Página siguiente',
        retry:'Intentar ahora',
        retry_late:'Intentar más tarde',
    },
    start: { 
        title: '¡Bienvenid@!',
        description: 'Estamos cargando tu información, por favor espera.',
        no_id: '¡Ups! Ha ocurrido un problema',
        error_description: 'Por favor comunícate con la persona que te envió el correo para obtener ayuda.',

        welcome_test: '¡Bienvenid@ a Evaluación Mabe!',
        welcome_description_no_id: 'Si deseas iniciar una evaluación, por favor comunícate con la persona que te envió este enlace.',
        welcome_description: 'Esta evaluación ya no se encuentra disponible',
    },
    welcome: {
        title: "¡Bienvenido!",
        subtitle: "Está a punto de realizar una serie de evaluaciones.",
        desc1: "Necesita en promedio 30 minutos, piense sus respuestas y no responda apresuradamente.",
        desc2: "Elija la respuesta que mejor describa lo que usted haría en la siguiente situación.",
    },
    explanation:{
        title: "Antes de empezar recuerda que: ",
        desc1: "No existen respuestas buenas ni malas, sólo le pedimos que sea completamente honesto.",
        desc2: "Cada situación tiene un tiempo límite para que emita su respuesta, de no hacerlo en ese lapso, el sistema en automático avanzará a la siguiente situación y no podrá regresar. Por ello, es muy importante que mantenga toda su atención en la prueba y responda lo más rápido posible.",
        desc3: "En la parte inferior de la página se mostrará una",
        desc4:"barra de tiempo límite.",
        desc5:"Le sugerimos estar al pendiente de ella, para que conteste antes de que se le termine el tiempo.",
    },
    firstEvaluation: {
        title: "Instrucciones",
        subtitle: "Esta prueba consiste en conocer la forma en que usted reacciona ante determinadas situaciones.",
        desc: "En las siguientes pantallas, encontrará una serie de situaciones con cuatro opciones de respuesta. Por favor elija, dando click sobre la frase que corresponda a la opción de respuesta que mejor describa lo que usted haría en cada situación.",
        instructions: 'Elija la respuesta que mejor describa lo que usted haría en la siguiente situación.',
        title_example: 'Situación ejemplo:',
        title_question:'Situación:',
        desc_question:'Elija la respuesta que mejor describa lo que usted haría en la siguiente situación.',

        question_example: 'Acabas de ingresar a un nuevo empleo y es tu primer día. A la hora de la comida, te diriges al lugar destinado por la empresa para consumir tus alimentos. Una vez que has ocupado un lugar, se sientan a tu alrededor varios compañeros. ¿Qué harías?',
        answer1_example: 'Te levantas y buscas otro lugar dónde comer.',
        answer2_example: 'Utilizas tu celular para no platicar con nadie.',
        answer3_example: 'Tratas conversar con ellos para conocerlos.',
        answer4_example: 'Terminas de comer rápidamente para retirarte.',
    },
    secondEvaluation: {
        title:'Instrucciones',
        subtitle:'Esta prueba consiste en conocer su opinión sobre las siguientes frases. No existen respuestas buenas ni malas.',
        desc1:'Todas las frases tienen 4 opciones de respuesta: Totalmente en desacuerdo, En desacuerdo, De acuerdo y Totalmente de acuerdo. Elija la opción con la que más se identifique. Sólo puede elegir una respuesta por oración.',
        desc2:'Le pedimos que sea completamente honesto y sugerimos no pensar demasiado sus respuestas, ya que sólo queremos conocer su opinión.',
        instruction: 'Instrucciones',
        instruction_description: 'Elija la respuesta con la que más se identifique.',
        phrase: 'Frase',
        totally_disagree: 'Totalmente en desacuerdo',
        disagree: 'En desacuerdo',
        okay: 'De acuerdo',
        totally_agree: 'Totalmente de acuerdo',
        exam_percentage:'Porcentaje de avance',
    },
    wait:{
        title: "Siguiente evaluación ",
        subtitle: "¡Ya pronto termina!",
        desc1: "Tome un respiro corto, relájese y presione el botón para continuar."
    },
    thirdEvaluation:{
        title:'Instrucciones',
        i_desc1:'Examine las palabras de cada serie y seleccione bajo la <strong>columna “+”</strong> la casilla de la palabra que mejor describa su forma de ser o comportarse. Después, bajo la <strong>columna “-”</strong> seleccione la casilla de la palabra que menos describe su forma de ser o comportarse.',
        i_desc2:'<strong>Recuerde no realizar ninguna otra tarea, manténgase concentrado en esta actividad y evite distracciones.</strong>',
        desc: "Seleccione bajo la columna ",
        desc2: "lo que mejor lo describe",
        desc3: "lo que menos lo describe",
        desc4: "Ponga el cursor sobre la palabra para ver su significado",
        block: "Bloque",
        p_desc:"Seleccione una palabra con + para lo que mejor lo describe y una palabra con - para lo que menos lo describe.",
        p_desc_v2:"De cada bloque seleccione una palabra con + para lo que mejor lo describe y una palabra con - para lo que menos lo describe.", 
        p_desc2:"Presione la palabra para ver su significado",
        exam_percentage:'Porcentaje de avance',
    },
    final:{
        title: "¡Ha terminado!",
        desc1: "Muchas gracias por su tiempo.",
        desc2: "Para más información, contacte a la persona que le asignó la evaluación.",
        desc3: "Puede cerrar esta ventana"
    },
    message:{
        first_evaluation:'Se requiere seleccionar una opción',
        second_evaluation:'Conteste todas las preguntas antes de continuar',
        second_evaluationP:'Conteste la pregunta antes de continuar',
        third_evaluation:'Tienes bloques sin completar', 
        third_evaluationP:'El bloque no está completo',
        third_evaluation_block:'Hay bloques con errores',
        error_responses:'Las respuestas no se han guardado. Por favor, inténtalo de nuevo más tarde.',
        error_load_eval:'¡Oops! Parece que algo no funcionó al cargar la evaluación. ¿Te gustaría intentarlo de nuevo?',
        instructions_retry:'¡Listo! Puedes cerrar esta pestaña. Cuando vuelvas a abrir el enlace, cargaremos tu evaluación desde este punto.',
    }
}
export default dictionary